import { render, staticRenderFns } from "./addorupdate.vue?vue&type=template&id=66f59020&scoped=true"
import script from "./addorupdate.vue?vue&type=script&lang=js"
export * from "./addorupdate.vue?vue&type=script&lang=js"
import style0 from "./addorupdate.vue?vue&type=style&index=0&id=66f59020&prod&lang=css"
import style1 from "./addorupdate.vue?vue&type=style&index=1&id=66f59020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f59020",
  null
  
)

export default component.exports